import { Grid, ListItemSecondaryAction, InputLabel } from "@mui/material";
import React, { useEffect, useState, useContext } from "react";
import MainCard from "ui-component/cards/MainCard";
import { gridSpacing } from "store/constant";
import endpoints from "utils/services/EndPoints";
import Api from "utils/services/Api";
import Button from "@mui/material/Button";
import LoadingButton from "@mui/lab/LoadingButton";
import "./index.css";
import InputFieldSelectSimple from "components/inputSelect/InputFieldSelectSimple";
import FeatherIcon from "feather-icons-react";
//import utlizados
import { CuentasSocio, InitTipoProductoMS } from "utils/types";
import SubCard from "ui-component/cards/SubCard";
import TextFieldInput from "components/input/TextFieldInput";
import alerta from "sweetalert";
import { procesoOK, procesoWarning, procesoError } from "utils/Constantes";
import { getCodigoUsuario, getCodigoIfip } from "utils/Common";
export default function Caja() {
  // HOOKS DE ESTADO
  const [datosCuenta, setDatosCuenta] = useState(CuentasSocio());
  const [listaTipoProducto, setListaTipoProducto] = useState([]);
  const [openTipoProducto, setOpenTipoProducto] = useState(false);
  const [objTipoProducto, setObjTipoProducto] = useState({});
  const [listaTipoCuentas, setListaTipoCuentas] = useState([]);

  // OBTIENE TIPO DE TRANSACCION POR TIPO DE PRODUCTO
  const [listaDatosTransaccion, setListaDatosTransaccion] = useState([]);
  const [openTipoTransaccion, setOpenTipoTransaccion] = useState(false);
  const [objTipoTransaccion, setObjTipoTransaccion] = useState({});

  const [listSocio, setListSocio] = useState([]);
  const [openSocio, setOpenSocio] = useState(false);
  const [objSocio, setObjSocio] = useState({});
  const loadingSocios = openSocio && listSocio.length === 0;

  const [listCuentas, setListCuentas] = useState([]);
  const [openCuentas, setOpenCuentas] = useState(false);
  const [objCuentas, setObjCuentas] = useState({});
  const loadingCuentas = openCuentas && listCuentas.length === 0;
  const [loading, setLoading] = useState(false);
  // HOOKS USEEFECT
  // HOOKS DE ESTADO NOTIFICACIONES
  const [openNotificacion, setOpenNotificacion] = useState(false);
  const [visualizaMensaje, setVisualizaMensaje] = useState("");
  const [colorNotificacion, setColorNotificacion] = useState("");
  // FUNCIONES
  useEffect(() => {
    handleSearchTipoCuenta();
    handleSearchTipoProducto();
    handleSearchTipoTransaccion();
  }, []);

  useEffect(() => {
    handleSearchListadoSocios();
  }, [loadingSocios]);

  useEffect(() => {
    if (!objSocio) {
      alerta("Seleccione Socio");
      return;
    }
    console.log("---error---");
    handleSearchListadoCuentas();
  }, [loadingCuentas]);

  const handleSearchListadoSocios = () => {
    try {
      (async () => {
        Api(endpoints.listadoSocio + "/" + getCodigoIfip(), "GET", null)
          .then((response) => {
            setListSocio(response);
          })
          .catch((error) => {
            console.log(error);
          });
      })();
    } catch (error) {
      console.log("Error en consulta Lista de Socios");
      console.log(error.message);
    }
  };

  const handleSearchListadoCuentas = () => {
    try {
      console.log("ojasd ");
      console.log(objSocio);
      (async () => {
        Api(
          endpoints.listadoCuentas +
          "/" +
          objSocio.codigo +
          "/" +
          getCodigoIfip(),
          "GET",
          null
        )
          .then((response) => {
            setListCuentas(response);
          })
          .catch((error) => {
            console.log(error);
          });
      })();
    } catch (error) {
      console.log("Error en consulta Lista de Socios");
      console.log(error.message);
    }
  };

  const onChanceSocio = (value) => {
    setObjSocio({});
    setListCuentas([]);
    setObjCuentas({});
    if (value === undefined) return;
    setObjSocio(value);
  };

  const onChanceCuentas = (value) => {
    setObjCuentas({});
    if (value === undefined) return;
    datosCuenta.numeroCuenta = value.numeroCuenta;
    setObjCuentas(value);
  };

  const handleSearchTipoCuenta = () => {
    try {
      // const data = await Api(endpoints.listPlazos, "GET", null)
      (async () => {
        Api(endpoints.listTipoCuentas, "GET", null)
          .then((response) => {
            setListaTipoCuentas(response);
          })
          .catch((error) => {
            console.log(error);
            // generaNotificacion(error.message);
          });
      })();
    } catch (error) {
      console.log("Error en consulta de servicio plazos");
    }
  };

  const handleSearchTipoProducto = () => {
    try {
      console.log("tipo producto ciit");
      (async () => {
        Api(endpoints.listTipoProducto, "GET", null)
          .then((response) => {
            console.log("Datos de retorno Tipo Producto");
            console.log(response);
            setListaTipoProducto(response);
          })
          .catch((error) => {
            console.log(error);
          });
      })();
    } catch (error) {
      console.log("Error en consulta de servicio productoActFin");
    }
  };
  const handleSearchTipoTransaccion = () => {
    try {
      console.log("error " + objTipoProducto.codigo);
      (async () => {
        Api(endpoints.listTipoTransaccion, "GET", null)
          .then((response) => {
            console.log("Datos de Tipo Transaccion ver");
            console.log("response " + response);
            setListaDatosTransaccion(response);
          })
          .catch((error) => {
            console.log(error);
          });
      })();
    } catch (error) {
      console.log("Error en consulta datos Transaccion Producto");
      console.log(error.message);
    }
  };

  // FUNCION PARA REGISTRO DE INFORACION
  const handleSearchCuenta = () => {
    setDatosCuenta(CuentasSocio());
    setLoading(true);

    try {
      (async () => {
        Api(
          endpoints.obtieneDatosCuenta + "/" + datosCuenta.numeroCuenta,
          "GET",
          null
        )
          .then((response) => {
            console.log("Datos de Cuenta");
            console.log(response);

            if (response.codigo === 0) {
              setDatosCuenta(CuentasSocio());
              alerta("No existe datos de la cuenta ingresada");
            } else {
              setDatosCuenta(response);
            }
            setLoading(false);
          })
          .catch((error) => {
            setLoading(false);
            console.log(error);
          });
      })();
    } catch (error) {
      console.log("Error en consulta datos cuenta");
      console.log(error.message);
    }
  };

  // FUNCIONES ADMINSITRACION
  const handleSave = () => {
    if (datosCuenta.numeroCuenta === undefined) {
      alerta("Ingrese el numero de cuenta. ");
      console.log("Ingrese el numero de cuenta. ");
      return;
    }

    if (datosCuenta.saldoDisponible === undefined) {
      alerta("No existe saldo disponible de la cuenta. ");
      console.log("No existe saldo disponible de la cuenta. ");
      return;
    }

    if (datosCuenta.personMs.nombres === undefined) {
      alerta("No existe la persona seleccionada ");
      console.log("No existe la persona seleccionada. ");
      return;
    }

    if (datosCuenta.valorEfectivo === undefined) {
      alerta("Ingrese el monto de la transaccion. ");
      console.log("Ingrese el monto de la transaccion. ");
      return;
    }

    if (datosCuenta.observacion === undefined) {
      console.log(datosCuenta);
      alerta("Ingrese una observacion para la transaccion. ");
      console.log("Ingrese la observacion. ");
      return;
    }

    if (
      objTipoTransaccion.value.codigo === 2 &&
      datosCuenta.saldoDisponible < datosCuenta.valorEfectivo
    ) {
      alerta("El monto de retiro no puede ser mayor al saldo disponible  ");
      console.log("El monto de retiro no puede ser mayor al saldo  ");
      return;
    }

    const codigo = 1;
    // Arma objeto
    const objMovimientoRegistro = {
      codigo: 0,
      codigoAgencia: 1,
      codigoEntidad: getCodigoIfip(),
      codigoCanal: 1,
      codigoUsuarioRegistra: getCodigoUsuario(),
      codigoUsuarioActualiza: getCodigoUsuario(),
      debitoCredito: objTipoTransaccion.value.codigo === 1 ? "C" : "D",
      nombreMaquina: "PRUEBA REACT",
      observacion: datosCuenta.observacion,
      valorCheque: 0,
      valorEfectivo: datosCuenta.valorEfectivo,
      valorSaldo:
        objTipoTransaccion.value.codigo === 1
          ? parseFloat(datosCuenta.saldoDisponible) +
          parseFloat(datosCuenta.valorEfectivo)
          : parseFloat(datosCuenta.saldoDisponible) -
          parseFloat(datosCuenta.valorEfectivo),
      valorTransaccion: datosCuenta.valorEfectivo,
      codigoProducto: objTipoProducto.value.codigo,
      codigoTransaccion: objTipoTransaccion.value.codigo,
      fechaActualiza: Date.now(),
      fechaRegistro: Date.now(),
      numeroCuenta: datosCuenta.numeroCuenta,
      codigoCuenta: datosCuenta.codigo,
    };
    console.log(objMovimientoRegistro);

    const codigoUno = 1;
    setLoading(true);
    if (codigoUno === 1) {
      (async () => {
        Api(endpoints.saveMovimiento, "POST", objMovimientoRegistro)
          .then((response) => {
            if (response.estado === 1) {
              setLoading(false);
              generarNotificacion(true, response.mensaje, 1);
             // downloadBase64PDF(response.documentoGenerado.reportePdf, `registro_socio_${codigoPersona}`);
            } else {
              setLoading(false);
              alerta(response.mensaje);
            }
          })
          .catch((error) => {
            setLoading(false);
            console.log(error);
          });
      })();
    }
  };

  const generarNotificacion = (abrir, mensaje, color) => {
    setOpenNotificacion(abrir);
    setVisualizaMensaje(mensaje);
    if (color === 1) {
      setColorNotificacion(procesoOK);
    }
    if (color === 2) {
      setColorNotificacion(procesoWarning);
    }
    if (color === 3) {
      setColorNotificacion(procesoError);
    }
  };
  const setInitComponent = () => {
    setDatosCuenta(CuentasSocio());
    setListaTipoProducto();
    handleSearchTipoProducto();
  };

  const cerrarNotificacion = () => {
    setOpenNotificacion(false);
  };
  // VISTA (Aqui se renderiza todas las personas)
  const tamanoCaja = 6;
  return (
    <>
      {
        <MainCard
          title="Movimientos"
          open={openNotificacion}
          mensajeVizualizar={visualizaMensaje}
          colorProceso={colorNotificacion}
          handleClose={() => cerrarNotificacion()}
          secondary={
            <ListItemSecondaryAction link="https://next.material-ui.com/system/typography/" />
          }
        >
          <Grid container xs={12} spacing={gridSpacing}>
            <Grid item xs={12}>
              <SubCard
                style={{ alignItems: "center" }}
                title="TIPO TRANSACCION"
              >
                <Grid container xs={12} spacing={gridSpacing}>
                  <Grid item md={tamanoCaja}>
                    <InputFieldSelectSimple
                      id={"idTipoProducto"}
                      md={tamanoCaja}
                      variant={"outlined"}
                      label={"Tipo Producto"}
                      loading={false}
                      open={openTipoProducto}
                      onOpen={() => {
                        setOpenTipoProducto(true);
                      }}
                      onClose={() => {
                        setOpenTipoProducto(false);
                      }}
                      options={listaTipoProducto}
                      getOptionLabel={(option) => option.descripcion}
                      value={objTipoProducto.descripcion}
                      onChange={(event, value) => {
                        setObjTipoProducto((prevState) => {
                          return { ...prevState, value };
                        });
                      }}
                    />
                  </Grid>
                  <Grid item md={tamanoCaja}>
                    <InputFieldSelectSimple
                      id={"idTipoTransaccion"}
                      md={tamanoCaja}
                      variant={"outlined"}
                      label={"Tipo Transaccion"}
                      loading={false}
                      open={openTipoTransaccion}
                      onOpen={() => {
                        setOpenTipoTransaccion(true);
                      }}
                      onClose={() => {
                        setOpenTipoTransaccion(false);
                      }}
                      options={listaDatosTransaccion}
                      getOptionLabel={(option) => option.descripcion}
                      value={objTipoTransaccion.descripcion}
                      onChange={(event, value) => {
                        setObjTipoTransaccion((prevState) => {
                          return { ...prevState, value };
                        });
                      }}
                    />
                  </Grid>
                </Grid>
              </SubCard>
              <SubCard
                style={{ alignItems: "center" }}
                title="VALORES DE TRANSACCION"
              >
                <Grid container xs={12} spacing={gridSpacing}>
                  <Grid item md={tamanoCaja}>
                    <InputFieldSelectSimple
                      id={"idSocios"}
                      md={tamanoCaja}
                      variant={"outlined"}
                      label={"Listado Socios"}
                      loading={false}
                      open={openSocio}
                      onOpen={() => {
                        setOpenSocio(true);
                      }}
                      onClose={() => {
                        setOpenSocio(false);
                      }}
                      options={listSocio}
                      getOptionLabel={(option) =>
                        option.personaMs.numeroIdentificacion +
                        " - " +
                        option.personaMs.nombres.toUpperCase()
                      }
                      value={objSocio.codigo}
                      onChange={(event, value) => {
                        onChanceSocio(value);
                      }}
                    />
                  </Grid>
                  <Grid item md={tamanoCaja}>
                    <InputFieldSelectSimple
                      id={"idCuentas"}
                      md={tamanoCaja}
                      variant={"outlined"}
                      label={"Listado Cuentas"}
                      loading={false}
                      open={openCuentas}
                      onOpen={() => {
                        setOpenCuentas(true);
                      }}
                      onClose={() => {
                        setOpenCuentas(false);
                      }}
                      options={listCuentas}
                      getOptionLabel={(option) =>
                        option ? option.numeroCuenta : ""
                      }
                      value={objCuentas.codigo}
                      onChange={(event, value) => {
                        onChanceCuentas(value);
                      }}
                    />
                  </Grid>
                </Grid>

                <Grid container xs={12} spacing={gridSpacing}>
                  <Grid item md={tamanoCaja}>
                    <TextFieldInput
                      fullWidth
                      label="saldo"
                      varianField={"outlined"}
                      value={datosCuenta.saldoDisponible}
                      disabled
                    />
                  </Grid>
                  <Grid item md={tamanoCaja} flexGrow>
                    <TextFieldInput
                      fullWidth
                      varianField={"outlined"}
                      value={datosCuenta.valorEfectivo}
                      label="valor"
                      onChange={(e) => {
                        const valor = e.target.value;
                        setDatosCuenta((prevState) => {
                          return { ...prevState, valorEfectivo: valor };
                        });
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid container xs={12} spacing={gridSpacing}>
                  <Grid item md={12}>
                    <TextFieldInput
                      md={tamanoCaja}
                      fullWidth
                      varianField={"outlined"}
                      value={datosCuenta.observacion}
                      label="observación"
                      onChange={(e) => {
                        const valor = e.target.value;
                        setDatosCuenta((prevState) => {
                          return { ...prevState, observacion: valor };
                        });
                      }}
                    />
                  </Grid>
                </Grid>
              </SubCard>
            </Grid>
          </Grid>
          <div style={{ width: "100%" }}>
            <div className="steps-action">
              <LoadingButton
                type="primary"
                block
                htmlType="submit"
                loading={loading}
                onClick={() => setInitComponent()}
              >
                <FeatherIcon icon="plus" size={16} /> &nbsp;Nueva Transaccion{" "}
              </LoadingButton>
              <LoadingButton
                type="primary"
                block
                htmlType="submit"
                loading={loading}
                onClick={() => handleSearchCuenta()}
              >
                <FeatherIcon icon="search" size={16} /> &nbsp;Consultar Cuenta{" "}
              </LoadingButton>
              <LoadingButton
                type="primary"
                block
                htmlType="submit"
                loading={loading}
                onClick={() => handleSave()}
              >
                <FeatherIcon icon="save" size={16} /> &nbsp;Grabar Transaccion{" "}
              </LoadingButton>
            </div>
          </div>
        </MainCard>
      }
    </>
  );
}
